import React, { useState, useEffect } from 'react'
import { useHistory, withRouter } from 'react-router-dom';
import { sendInvite } from '../../common/api';
import { emailRegex } from '../../common/constants';
import { isCompanyEmail } from '../../common/emailValidator';
import ToastMessage from '../../components/common/ToastMessage';

import {
   Button, Input, Message
} from 'semantic-ui-react'

export const NewInviteUser = () => {
   const history = useHistory();
   const [inviteStatus, setInviteStatus] = useState('')
   const [email, setEmail] = useState('')
   const [invitationMessage, setInviteMessage] = useState('')
   const [messageToggle, showMessage] = useState(false)
   const [messageType, setMessageType] = useState('')

   const handleInputChange = (e) => {
      console.log('e ', e)
      setEmail(e.target.value)
      localStorage.removeItem('user_data')
   }

   const SendInviteEmail = () => {
      if (!email) return;
      if (!emailRegex.test(email.trim())) return;
      if (isCompanyEmail(email)) {
         setInviteStatus("in progress");
         sendInvite(email).then(() => {
            setInviteStatus("sent");
            setInviteMessage("Thank you for showing your interest in Mappes. A representative from our team will get in touch with you shortly.");
            setMessageType('S')
            showMessage(true)
            setTimeout(() => {
               localStorage.setItem('email', email)
               history.push('/otp-login');
            }, 1500);
         }
         );
      } else {
         setInviteMessage('Please use official email id to Login/Register ')
         setMessageType('E')
         showMessage(true)
         /* setTimeout(() => {
            showMessage(false)
         }, 4000); */
      }
   }

   return (
      <>
         {messageToggle && <ToastMessage type={messageType} msg={invitationMessage} show={messageToggle} position={'bottom-right'} />}
         <div className='email-col'>
            <Input placeholder='Enter Business Email' value={email} onChange={handleInputChange} />
            <Button primary onClick={() => SendInviteEmail()} loading={inviteStatus == "in progress"}>Join Mappes</Button>
         </div>
         {/* {
            inviteStatus === "sent" && invitationMessage &&
            <Message positive size="mini">
               <Message.Header>{invitationMessage}</Message.Header>
            </Message>
         } */}
      </>
   )

}